import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import StickyMobileCTA from "@/components/landing/StickyMobileCTA";
import { POSTS } from "@/seo/content";

const BlogIndex = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const posts = Object.values(POSTS);

  return (
    <div className="bg-maif text-maif min-h-screen">
      <Helmet>
        <title>Blog — AI in Morocco | Moroccan AI Factory</title>
        <meta name="description" content="Insights on AI agents, chatbots, automation and AI development in Morocco. Practical guides for SMEs and African operators." />
        <link rel="canonical" href="https://maif.ma/blog" />
        <link rel="alternate" hrefLang="en" href="https://maif.ma/blog" />
        <link rel="alternate" hrefLang="fr" href="https://maif.ma/blog" />
        <link rel="alternate" hrefLang="ar" href="https://maif.ma/blog" />
        <link rel="alternate" hrefLang="x-default" href="https://maif.ma/blog" />
        <meta property="og:title" content="Blog — AI in Morocco | Moroccan AI Factory" />
        <meta property="og:description" content="Insights on AI agents, chatbots, automation and AI development in Morocco." />
        <meta property="og:url" content="https://maif.ma/blog" />
        <meta property="og:type" content="website" />
      </Helmet>
      <Header />
      <main className="pt-28 sm:pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-10">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-maif-muted hover:text-maif transition mb-8">
            <ArrowLeft size={14} /> Back to home
          </Link>
          <div className="eyebrow">Blog</div>
          <h1 className="mt-4 font-display font-light text-4xl md:text-5xl tracking-tighter text-maif">
            AI in Morocco — practical guides for operators
          </h1>
          <p className="mt-6 text-lg text-maif-muted max-w-2xl">
            No fluff, no slide-ware. Real playbooks for SMEs and African enterprises adopting AI.
          </p>

          <div className="mt-14 space-y-4">
            {posts.map((p) => (
              <Link
                key={p.slug}
                to={`/blog/${p.slug}`}
                className="block rounded-2xl bg-maif-2 border border-sand-soft p-6 md:p-8 hover:border-sand-mid hover:-translate-y-0.5 transition"
              >
                <div className="eyebrow text-[10px]">{p.date}</div>
                <h2 className="mt-3 font-display text-xl md:text-2xl text-maif tracking-tight">{p.h1}</h2>
                <p className="mt-3 text-maif-muted text-sm md:text-base">{p.description}</p>
                <div className="mt-4 inline-flex items-center gap-1.5 text-sm text-terracotta">
                  Read article <ArrowUpRight size={14} />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
};

export default BlogIndex;
